/**
 * Interogare la nivel de pixel — click pe hartă → serie temporală → grafic.
 */
import { nearestIndex, extractTimeSeries, timesToDates } from './data.js';
import { getAqiCategory, LABELS, UNITS } from './colormaps.js';
import { placeMarker } from './map.js';
import { drawChart, updateChartCursor } from './chart.js';

let currentPixel = null;

/**
 * Handler de click pe hartă.
 * @param {number} lng
 * @param {number} lat
 * @param {object} cube - Cubul de date curent
 * @param {string} variable - Variabila curentă
 * @param {number} currentTimeIndex - Indexul de timp curent
 */
export function handlePixelClick(lng, lat, cube, variable, currentTimeIndex) {
  const lonIdx = nearestIndex(cube.lons, lng);
  const latIdx = nearestIndex(cube.lats, lat);

  // Coordonatele reale ale celulei
  const realLon = Number(cube.lons[lonIdx]);
  const realLat = Number(cube.lats[latIdx]);

  // Extrage seria temporală
  const series = extractTimeSeries(cube, latIdx, lonIdx);
  const dates = timesToDates(cube.times, cube.timeAttrs);

  // Valoarea curentă
  const currentValue = series[currentTimeIndex];

  // Salvăm starea
  currentPixel = { lonIdx, latIdx, realLon, realLat, series, dates };

  // Plasează marker pe hartă
  placeMarker(realLon, realLat);

  // Actualizează UI panoul pixel
  showPixelPanel(variable, realLon, realLat, currentValue, currentTimeIndex);

  // Desenează graficul
  drawChart(dates, series, variable, currentTimeIndex);
}

/**
 * Actualizează valoarea afișată când se schimbă timestep-ul.
 */
export function updatePixelValue(variable, timeIndex) {
  if (!currentPixel) return;

  const value = currentPixel.series[timeIndex];
  const valueEl = document.getElementById('pixel-value');
  const qualityEl = document.getElementById('pixel-quality');

  if (value != null) {
    valueEl.textContent = value.toFixed(1);
    const cat = getAqiCategory(value, variable);
    if (cat) {
      qualityEl.textContent = cat.label;
      qualityEl.style.background = cat.color + '22';
      qualityEl.style.color = cat.color;
    }
  } else {
    valueEl.textContent = '—';
    qualityEl.textContent = '—';
    qualityEl.style.background = '';
    qualityEl.style.color = '';
  }

  // Actualizează cursorul pe grafic
  updateChartCursor(timeIndex);
}

/**
 * Re-calculează seria temporală pentru noua variabilă (la schimbare poluant).
 */
export function refreshPixelForVariable(cube, variable, timeIndex) {
  if (!currentPixel) return;

  const series = extractTimeSeries(cube, currentPixel.latIdx, currentPixel.lonIdx);
  const dates = timesToDates(cube.times, cube.timeAttrs);
  currentPixel.series = series;
  currentPixel.dates = dates;

  const currentValue = series[timeIndex];
  showPixelPanel(variable, currentPixel.realLon, currentPixel.realLat, currentValue, timeIndex);
  drawChart(dates, series, variable, timeIndex);
}

/**
 * Returnează starea pixelului curent (sau null).
 */
export function getCurrentPixel() {
  return currentPixel;
}

/**
 * Închide panoul pixel.
 */
export function closePixelPanel() {
  const panel = document.getElementById('pixel-panel');
  panel.classList.add('hidden');
  currentPixel = null;
}

// ── UI ───────────────────────────────────────────────────────────
function showPixelPanel(variable, lon, lat, value, timeIndex) {
  const panel = document.getElementById('pixel-panel');
  panel.classList.remove('hidden');

  document.getElementById('pixel-var-label').textContent = LABELS[variable] || variable;
  document.getElementById('pixel-coords').textContent =
    `${lat.toFixed(2)}°N, ${lon.toFixed(2)}°E`;
  document.getElementById('pixel-unit').textContent = UNITS[variable] || 'µg/m³';

  const valueEl = document.getElementById('pixel-value');
  const qualityEl = document.getElementById('pixel-quality');

  if (value != null) {
    valueEl.textContent = value.toFixed(1);
    const cat = getAqiCategory(value, variable);
    if (cat) {
      qualityEl.textContent = cat.label;
      qualityEl.style.background = cat.color + '22';
      qualityEl.style.color = cat.color;
    }
  } else {
    valueEl.textContent = '—';
    qualityEl.textContent = '—';
  }
}
